import React from "react";
import { normalizeColorValue } from "../shared";
import "../DesignerPropertiesPanel.css";
import "./ColorField.css";

const ColorField = ({ label, value, onTextChange, onPickerChange, fallback }) => {
  const pickerValue = normalizeColorValue(value, fallback);

  return (
    <div className="dp-color-field">
      <label className="dp-label">{label}</label>

      <div className="dp-color-grid">
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onTextChange(e.target.value)}
          placeholder={fallback}
          className="dp-input"
        />

        <input
          type="color"
          value={pickerValue}
          onChange={(e) => onPickerChange(e.target.value)}
          className="dp-color-picker"
        />
      </div>
    </div>
  );
};

export default ColorField;